import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useOrderReceipt(orderId: string) {
    const { data: receipt, status } = useQuery(queries.orders.receipt(orderId));
    const isLoading = status === 'pending';
    return {
        isLoading, receipt,
    };
}

export default useOrderReceipt;
